import Swiper, { Lazy, Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initializeSliderBooks(containerId) {
    const containerSlider = $(containerId);

    const swiperRecipe = new Swiper(containerId + ' .swiper-no-padding ', {
        modules: [Navigation, Pagination, Lazy, Scrollbar],

        slidesPerView: 'auto',

        breakpoints: {
            0: {
                spaceBetween: 8,                
            },
            //md
            768: {
                spaceBetween: 24,
            },
        },

        pagination: {
            el: containerId + ' .swiper-pagination',
            type: 'progressbar',
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 4,
        },

        navigation: {
            prevEl: containerId + ' #click-prev-slider-ebooks',
            nextEl: containerId + ' #click-next-slider-ebooks',
        },
    });

    swiperRecipe.on('slideChange', function () {
        // Atualizar número do slide atual
        const currentPage = (this.realIndex + 1).toString().padStart(2, '0');
        containerSlider.find('.slider-current-page').html(currentPage);
        containerSlider.find('.slider-progress .progress-fill').css('width', Math.min(this.progress * 100, 100) + '%');
    });
}

$(function () {
    $('.slider-books, .slider-ebooks').each(function () {
        initializeSliderBooks('#' + $(this).attr('id'));
    });
});
